import React from "react";
import EmpSidebar from "../components/Sidebar/EmpSidebar";
import EmpHeader from "../components/Header/EmpHeader";
import { Outlet } from "react-router-dom";

export default function EmployeeLayout() {
  return (
    <div className="flex h-screen">
      <EmpSidebar />

      <div className="flex-1 flex flex-col">
        <EmpHeader />

        <main className="flex-1 overflow-auto p-6 bg-gray-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
